const environments = {
  production: {
    tide: {
      url: "https://tide-services.three-shelves.com/"
    }
  },
  development: {
    tide: {
      url: "https://tide-uat-services.three-shelves.com/"
    }
  },
  local: {
    tide: {
      url: "https://tide-uat-services.three-shelves.com/"
    }
  }
}
export default environments
